import { FunctionComponent, useMemo, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useWorkroom } from './WorkroomContext'
import { deleteFile, deleteFolder } from 'Frontend/scripts/services/workrooms.service'
import { WorkroomItemType } from 'Frontend/scripts/models/workrooms.model'
import Dialog from 'Features/Dialog/Dialog'
import { useTranslation } from 'react-i18next'

const WorkroomDeleteItemButton: FunctionComponent = () => {
  const { selectedFiles, fetchFilesAndFolders, currentWorkroomId } = useWorkroom()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  const canMoveFileOrFolder = useMemo(() => {
    return selectedFiles.length > 0
  }, [selectedFiles])

  const deleteFilesAndFolders = () => {
    const deletePromises = selectedFiles.map((item) => {
      if (item.type === WorkroomItemType.FILE) {
        return deleteFile(currentWorkroomId as string, item.id.toString())
      } else {
        return deleteFolder(currentWorkroomId as string, item.id.toString())
      }
    })
    return Promise.all(deletePromises).then(() => {
      fetchFilesAndFolders()
      setIsOpen(false)
    })
  }

  return (
    <>
      <Button variant="secondary" className="fw-normal" disabled={!canMoveFileOrFolder} onClick={() => setIsOpen(true)}>
        <i className={`fa fa-trash-o small me-1`} />
        {t('delete')}
      </Button>
      <Dialog
        abortText={t('abort')}
        submitText={t('yes')}
        isOpen={isOpen}
        callbackSubmit={() => deleteFilesAndFolders()}
        callbackClose={() => setIsOpen(false)}
        verificationText={t('workrooms.documents.delete-file-or-folder-validation-text')}
        buttonVariant="secondary"
      />
    </>
  )
}
export default WorkroomDeleteItemButton
